import store from './../../../store';
import acctService from './../../../services/account';

export default {
  data() {
    return {
      userid: 0,
      token: '',
      email: '',
      status: 'checking',
      password1: '',
      password2: '',
      errmsg: '',
    };
  },
  mounted() {
    this.status = 'checking';
    // return;
    const userid = this.getParameterByName('i');
    const token = this.getParameterByName('token');
    if (!userid || userid == '') {
      this.status = 'check-fail';
      this.errmsg = 'No user id in URL';
      return;
    }
    if (!token || token == '') {
      this.status = 'check-fail';
      this.errmsg = 'No token in URL';
      return;
    }
    this.checktoken(userid, token);
  },
  methods: {
    getParameterByName(name, url) {
    		if (!url) {
    			url = window.location.href;
    		}
    		name = name.replace(/[\[\]]/g, "\\$&");
    		var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    				results = regex.exec(url);
    		if (!results) return null;
    		if (!results[2]) return '';
    		return decodeURIComponent(results[2].replace(/\+/g, " "));
    },
    checktoken(userid, token) {
      // console.log(userid, token);
      this.errmsg = '';
      this.doingSomething = true;
      this.userid = userid;
      this.token = token;
      const vm = this;
      const clearErrMsg = function clearErrMsg() { vm.doingSomething = false; vm.errmsg = ''; };
      const cbSuccess = function cbSuccess(response) {
        console.log('response check');
        console.log(response);
        vm.status = 'check-ok';
        vm.errmsg = '';
        vm.doingSomething = false;
        vm.emailSent = true;
        vm.errmsg = '';
      };
      const cbFail = function cbFail(response) {
        vm.status = 'check-fail';
        vm.errmsg = 'Password reset link validation failed';
        vm.doingSomething = false;
        if (response && response.data && response.data.err_message) {
          vm.errmsg = `Error checking password token - ${response.data.err_message}`;
        } else {
          vm.errmsg = 'Error checking password token - Please try reset password again';
        }
      };
      const cbOptions = {
        cbSuccess,
        cbFail,
      };
      if (!userid || !token) {
        vm.errmsg = 'Internal error - Please logout and login again';
      }
      acctService.checkpwlink(this.userid, this.token, cbOptions);
      //
    },
    isStrongPwd1(password) {
        const regExp = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%&*()]).{8,}/;
        const validPassword = regExp.test(password);
        return validPassword;
    },
    resetpw() {
      // console.log(password1, password2);
      if (!this.password1) {
        this.errmsg = 'You must supply a new password';
        return;
      }
      if (!this.password2) {
        this.errmsg = 'You must confirm your new password';
        return;
      }
      if (this.password1 !== this.password2) {
        this.errmsg = 'Two passwords do not match';
        return;
      }
      if (this.password1.length < 8) {
        this.errmsg = 'Password does not meet minimum length requirement';
        return;
      }
      if (!this.isStrongPwd1(this.password1)) {
        this.errmsg = 'Password does not meet minimum complexity requirements';
        return;
      }
      this.doingSomething = true;
      this.errmsg = '';
      const vm = this;
      const cbSuccess = function cbSuccess(response) {
        vm.errmsg = '';
        vm.doingSomething = false;
        vm.status = 'done';
      };
      const cbFail = function cbFail(response) {
        vm.errmsg = 'Password change failed';
        vm.doingSomething = false;
        if (response && response.data && response.data.err_message) {
          vm.errmsg = `Error changing password - ${response.data.err_message}`;
        } else {
          vm.errmsg = 'Error changing password - Please try again';
        }
      };
      const cbOptions = {
        cbSuccess,
        cbFail,
      };
      if (!this.userid || !this.token) {
        vm.errmsg = 'Internal error - Please logout and login again';
      }
      console.log('chaing the passwd');
      acctService.changePassword(this.userid, this.token, this.password1, cbOptions);
      // acctService.changePassword(this.userid, this.token, '', cbOptions);
    },
  },
  components: {
    VLayout: require('layouts/minimal/minimal.vue'),
    VPanel: require('components/panel/panel.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/user/pwresetlink/index.js